import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider, useAuth } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';

// Components
import Navbar from './components/Navbar';
import Seo from './components/Seo';
import HeroSection from './components/HeroSection';
import GamesShowcase from './components/GamesShowcase';
import WhatsNewSection from './components/WhatsNewSection';
import MonetizationFeature from './components/MonetizationFeature';
import AssetsSection from './components/AssetsSection';
import MapEditorSection from './components/MapEditorSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import GameCreator from './pages/GameCreator';
import GameDetail from './pages/GameDetail';
import Pricing from './pages/Pricing';
import Help from './pages/Help';
import GamePlayer from './pages/GamePlayer';
import Arcade from './pages/Arcade';
import CreatorProfile from './pages/CreatorProfile';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Seo
        title="GameOS – AI Game Builder: Create 2D & 3D HTML5 Games from a Prompt"
        description="Build cinematic 2D and 3D HTML5 games by chatting with 55 AI models including GPT-6 Astra. Share, remix and earn ad revenue from day one — no code required."
        path="/"
      />
      <Navbar />
      <HeroSection />
      <WhatsNewSection />
      <GamesShowcase />
      <MonetizationFeature />
      <AssetsSection />
      <MapEditorSection />
      <FAQSection />
      <Footer />
    </div>
  );
};

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/games" element={<Arcade />} />
              <Route path="/creator/:username" element={<CreatorProfile />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/help" element={<Help />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/create"
                element={
                  <ProtectedRoute>
                    <GameCreator />
                  </ProtectedRoute>
                }
              />
              <Route path="/game/:gameId" element={<GameDetail />} />
              {/* Public play routes for shared links */}
              {/* New format: /play/<slug>/<gameId> */}
              <Route path="/play/:slug/:gameId" element={<GamePlayer />} />
              {/* Legacy format (single slug+id segment): /play/<slug-and-gameId> */}
              <Route path="/play/:slugAndId" element={<GamePlayer />} />
            </Routes>
            <Toaster />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;